import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { DraftMealPlanTable } from "./DraftMealPlanTable";
import { draftMealPlanService } from "./service/drafMealPlan.service";
import ConfirmationModal from "../../../Shared/ConfirmationModal";
import { toast } from "react-toastify";

class ManageDraftMealPlanTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            submitting: false,
            formError: null,
            data: null,
            selectedRow: null,
            hasParams: false,
            error: null,
            pageNum: 0,
            pageSize: 5,
            showModal: false,
            notResetMode: false,
            //   status: "DRAFT",
        };
    }
    componentDidMount() {
        const { pageNum, pageSize } = this.state;
        this.getAllDraftMealPlans({ "page-num": pageNum + 1, "page-size": pageSize });
    }

    getAllDraftMealPlans = (params) => {
        this.setState({ fetching: true });
        draftMealPlanService
            .getSendMealPlans(params)

            .then((response) => {
            
                response &&
                    this.setState({
                        data: response,
                        pages: Math.ceil(response.count / params["page-size"]),
                        error: null,
                        fetching: false,
                    });
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };
    deleteMealPlan = async () => {
        const { pageSize, selectedRow } = this.state;
        try {
            let response = await draftMealPlanService.deleteDailyMealPlan(selectedRow && selectedRow.id);
            if (response == null) {
                toast.success("Meal plan deleted successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.reset();
                //update table...
                this.getAllDraftMealPlans({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
                showModal: !this.state.showModal,
            });
        }
    };

    fetchData = () => {
        const { pageNum, pageSize, filterParams } = this.state;
        let params = { "page-num": pageNum + 1, "page-size": pageSize };
        if (filterParams) {
            params = { ...filterParams, ...params };
        }
        this.getAllDraftMealPlans(params);
    };

    setPageNumber = (pageIndex) => {
        this.setState({ pageNum: pageIndex }, () => this.fetchData());
    };

    setPageSize = (pageSize, pageIndex) => {
        this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
    };

    filterData = (params) => {
        this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
    };

    selectRow = (selectedRow) => {
        this.setState({ selectedRow: selectedRow.original, hasParams: true });
    };

    showConfirmation = (selectedRow) => {
        this.setState({
            selectedRow: selectedRow.original,
            showModal: !this.state.showModal,
        });
    };

    routeChange = () => {
        this.props.history.push({
            pathname: `/useruploadcontents`,
            state: { run: true },
        });
    };

    discardMealPlan = () => {
        this.deleteMealPlan();
    };

    reset = () => {
        this.setState({ submitted: false, selectedRow: null, hasParams: false, submitting: false, showModal: false });
    };

    render() {
        const { fetching, data, pages, pageNum, pageSize, error, hasParams, selectedRow } = this.state;

        return (
            <Row>
                <Col sm="12">
                    <DraftMealPlanTable
                        fetching={fetching}
                        hasParams={hasParams}
                        selectedRow={selectedRow}
                        data={data}
                        selectRow={this.selectRow}
                        error={error}
                        showModal={this.showConfirmation}
                        pages={pages}
                        page={pageNum}
                        pageSize={pageSize}
                        filterData={this.filterData}
                        setPageNumber={this.setPageNumber}
                        setPageSize={this.setPageSize}
                        postId={selectedRow}
                        routeChange={this.routeChange}
                      
                    />
                </Col>
                <ConfirmationModal isOpen={this.state.showModal} showModal={this.showConfirmation} action={this.discardMealPlan} item={selectedRow} message={"Do you want to discard your meal plan ?"} />
            </Row>
        );
    }
}

export default ManageDraftMealPlanTable;
